module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selectize', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.carehomes,
      "labelField": "name",
      "valueField": "name",
      "searchField": "name"
    },
    model: {
      value: (_vm.selection),
      callback: function($$v) {
        _vm.selection = $$v
      },
      expression: "selection"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b31a7414", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b31a7414"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/carehomeselector/carehomeselector.scp.html
// module id = 572
// module chunks = 0